module.exports = __webpack_public_path__ + "static/media/catoffline_medium@2x.882c6c9a.jpg";